import JSZip from "jszip";
import { saveAs } from "file-saver";

export const downloadZip = async (files, zipName = "documentos.zip") => {
  const zip = new JSZip();

  files.forEach((file) => {
    const binary = atob(file.base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    zip.file(file.nome, bytes);
  });

  const blob = await zip.generateAsync({ type: "blob" });
  saveAs(blob, zipName);
};
